import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import { setupOfflineInterceptor } from './utils/offlineQueue';

// Enable offline queueing for failed mutations
setupOfflineInterceptor(axios);

// Stale HMR chunks after edits or dev-server restarts cause ChunkLoadError; one reload usually fixes it.
if (process.env.NODE_ENV === 'development') {
  const isChunkFailure = (err) => {
    if (!err) return false;
    if (err.name === 'ChunkLoadError') return true;
    const m = String(err.message || err);
    return /Loading (?:CSS )?chunk|Loading .*\.hot-update/i.test(m);
  };
  const tryReload = () => {
    if (window.__hmrChunkReload) return;
    window.__hmrChunkReload = true;
    window.location.reload();
  };
  window.addEventListener('unhandledrejection', (e) => {
    if (isChunkFailure(e.reason)) {
      e.preventDefault();
      tryReload();
    }
  });
  window.addEventListener('error', (e) => {
    if (isChunkFailure(e.error || e.message)) tryReload();
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


